import React from "react"

export const Separator = () => {
    return(
        <hr className="mt-5 mb-5"/>
    )
}